import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { ToggleLeft, ToggleRight } from 'lucide-react';
import { useDrawingContext } from './DrawingContext';
export const PricingDisplay = React.memo(({ isVisible }) => {
    const { state, actions, computed } = useDrawingContext();
    const { area, ui } = state;
    const { areaUnit } = ui;
    const { areaInAcres } = computed;
    const polygonArea = useMemo(() => {
        if (areaUnit === 'acres') {
            return areaInAcres;
        }
        else {
            return areaInAcres * 0.404686;
        }
    }, [areaInAcres, areaUnit]);
    const formatArea = useCallback((areaValue) => {
        if (areaValue < 0.01)
            return `< 0.01`;
        if (areaValue < 1)
            return `${areaValue.toFixed(3)}`;
        if (areaValue < 10)
            return `${areaValue.toFixed(2)}`;
        if (areaValue < 100)
            return `${areaValue.toFixed(1)}`;
        return `${Math.round(areaValue).toLocaleString()}`;
    }, []);
    const isMaxAreaExceeded = useMemo(() => {
        const data = area.data;
        if (!data)
            return false;
        if (!data.success) {
            const msg = (data.message || '').toLowerCase();
            return msg.includes('maximum area');
        }
        return false;
    }, [area.data]);
    const isMinAreaNotMet = useMemo(() => {
        const data = area.data;
        if (!data)
            return false;
        if (!data.success) {
            const msg = (data.message || '').toLowerCase();
            return msg.includes('minimum area');
        }
        return false;
    }, [area.data]);
    if (!isVisible)
        return null;
    return (_jsx("div", { className: "flex items-center gap-4", children: _jsxs("div", { className: "rounded-lg shadow-lg p-2 border-2 w-[140px]", style: {
                backgroundColor: 'var(--sand)',
                borderColor: 'var(--pewter)'
            }, children: [_jsxs("div", { className: "flex items-center justify-center gap-1 mb-1 h-[20px]", children: [_jsx("span", { className: `text-xs transition-colors ${areaUnit === 'acres' ? 'font-semibold' : 'opacity-60'}`, style: { color: 'var(--charcoal)' }, children: "Acres" }), _jsx("button", { onClick: () => actions.setAreaUnit(areaUnit === 'acres' ? 'hectares' : 'acres'), className: "p-0.5 rounded transition-colors hover:bg-opacity-20", style: {
                                backgroundColor: 'transparent',
                                color: 'var(--forest)'
                            }, title: `Switch to ${areaUnit === 'acres' ? 'hectares' : 'acres'}`, children: areaUnit === 'acres' ? (_jsx(ToggleLeft, { size: 14 })) : (_jsx(ToggleRight, { size: 14 })) }), _jsx("span", { className: `text-xs transition-colors ${areaUnit === 'hectares' ? 'font-semibold' : 'opacity-60'}`, style: { color: 'var(--charcoal)' }, children: "Hectares" })] }), _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-xs uppercase tracking-wide opacity-70 mb-0.5", style: { color: 'var(--pewter)' }, children: "Area" }), _jsx("div", { className: "text-lg font-semibold", style: { color: (isMaxAreaExceeded || isMinAreaNotMet) ? '#ef4444' : 'var(--charcoal)' }, children: isMaxAreaExceeded ? '> Max' : isMinAreaNotMet ? '< Min' : formatArea(polygonArea) })] })] }) }));
});
PricingDisplay.displayName = 'PricingDisplay';
